const uuid = require('./uuid.js')

const messagesWhitelist = [ 'reset-game', 'next-level' ]


function updateSpriteList (vm) {
  const gameStage = vm.runtime.getTargetForStage()
  if (!gameStage) {
    return
  }
  let spriteList = Object.values(gameStage.variables).find(
    v => v.name === 'SpriteList'
  )
  if (!spriteList) {
    spriteList = gameStage.lookupOrCreateList(uuid(), 'SpriteList')
  }
  vm.runtime.targets.forEach(t => {
    if (spriteList.value.indexOf(t.sprite.name) === -1) {
      spriteList.value.push(t.sprite.name)
    }
    if (!t.isStage) {
      const visible = t.lookupOrCreateVariable(uuid(), '$visible')
      visible.value = t.visible
    }
  })
}


function updateAppliedGlitchesLists (vm, glitchApplications) {
  const originals = vm.runtime.targets.filter(
    t => t.isOriginal && !t.isStage
  )
  originals.forEach(target => {
    const targetGlitches = glitchApplications.filter(
      g => g.targetId === target.id
    )
    target.sprite.clones.forEach(t => {
      const glitchList = t.lookupOrCreateList(
        uuid(),
        '$applied_glitches'
      )
      glitchList.value = targetGlitches.map(g => g.glitchId)
    })
  })
}

function handleMessages (vm, emitter) {
  const stageTarget = vm.runtime.getTargetForStage()
  if (!stageTarget) {
    return
  }
  const messagesVar = stageTarget.lookupOrCreateList(
    uuid(),
    '$gamebender_messages'
  )
  const messages = messagesVar.value
  while (messages.length > 0) {
    const messageArray = messages.pop().split(',')
      .map(string => string.trim())
    if (messagesWhitelist.includes(messageArray[0])) {
      emitter.emit(...messageArray)
    }
  }
}


module.exports = {
  updateAppliedGlitchesLists,
  updateSpriteList,
  handleMessages
}
